import * as React from 'react';
import styles from "./campaignInfo.module.scss";
import { Grid, Typography } from '@mui/material';
import { getDateTimeFromMillis } from '../../../utils/utils';

const CampaignInfo = ({ summary }) => {
    let startTime, endTime
    startTime = getDateTimeFromMillis(summary.startTime)
    endTime = getDateTimeFromMillis(summary.endTime)

    return (
        <Grid container item xs={4} className={styles.text} marginTop="10px" >
            <Grid item xs={12}>
                <Typography className={styles.heading}>{summary.campaignName}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography fontSize="16px">{startTime.date} {startTime.time} - {endTime.date} {endTime.time}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography component="pre" fontSize="14px">ID- {summary.campaignId} &nbsp;&nbsp;&nbsp;&nbsp; Created by: {summary.createdBy}</Typography>
            </Grid>
        </Grid>
    );
}
export default CampaignInfo